import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';
import i18n from 'i18next';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { TMS_SETTINGS_FIELDS } from '../../contants/common';
import { getErrorMessageFromAPI } from '../../utilz';
import { convertTmsSettingsApiToLocal } from '../../utilz/settingsUtils';
import { setAppLoader } from '../common/CommonActions';
import {
  getTmsSettingsInError,
  getTmsSettingsInProgress,
  getTmsSettingsInSuccess,
  saveTmsSettingsInError,
  saveTmsSettingsInSuccess,
} from './SettingsActions';
import {
  deleteTmsSettingsShipmentRestrictionEffect,
  getTmsSettingsEffect,
  saveTmsSettingsEffect,
} from './SettingsEffects';
import SettingsTypes from './SettingsTypes';

function* getTmsSettings({ payload }) {
  try {
    yield put(setAppLoader(true));
    const { data } = yield call(getTmsSettingsEffect, payload);
    yield put(
      getTmsSettingsInSuccess({
        data: convertTmsSettingsApiToLocal(data?.customerKey ? data : TMS_SETTINGS_FIELDS),
      }),
    );
    yield put(setAppLoader(false));
  } catch (e) {
    yield put(getTmsSettingsInError({ message: getErrorMessageFromAPI(e) }));
    yield put(setAppLoader(false));
  }
}

function* saveTmsSettings({ payload }) {
  const { selectedCompany } = yield select((state) => state.auth);

  try {
    yield call(saveTmsSettingsEffect, payload);
    yield put(
      saveTmsSettingsInSuccess({
        success: true,
      }),
    );
    yield put(getTmsSettingsInProgress({ customerKey: selectedCompany?.companyId }));

    yield call(showNotification, {
      type: NOTIFICATION_TYPES.SUCCESS,
      message: i18n.t('translation:default.fields.tmsSettingsSuccessfullySaved'),
    });
  } catch (e) {
    yield put(saveTmsSettingsInError({ message: getErrorMessageFromAPI(e) }));
    yield call(showNotification, {
      type: NOTIFICATION_TYPES.ERROR,
      message: i18n.t('translation:default.fields.failedToSave'),
    });
  }
}

function* deleteTmsSettingsShipmentRestriction({ payload }) {
  const { selectedCompany } = yield select((state) => state.auth);

  try {
    yield put(setAppLoader(true));
    yield call(deleteTmsSettingsShipmentRestrictionEffect, payload);
    yield put(
      saveTmsSettingsInSuccess({
        success: true,
      }),
    );
    yield put(getTmsSettingsInProgress({ customerKey: selectedCompany?.companyId }));
    yield put(setAppLoader(false));
  } catch (e) {
    yield put(saveTmsSettingsInError({ message: getErrorMessageFromAPI(e) }));
    yield call(showNotification, {
      type: NOTIFICATION_TYPES.ERROR,
      message: i18n.t('translation:default.notification.failedToDeleteItem'),
    });
    yield put(setAppLoader(false));
  }
}

export default function* settingsSaga() {
  yield takeLatest(SettingsTypes.GET_TMS_SETTINGS_PROGRESS, getTmsSettings);
  yield takeLatest(SettingsTypes.SAVE_TMS_SETTINGS_PROGRESS, saveTmsSettings);
  yield takeLatest(SettingsTypes.DELETE_TMS_SETTINGS_SHIPMENT_RESTRICTION, deleteTmsSettingsShipmentRestriction);
}
